module.exports = __webpack_public_path__ + "static/img/logo.f0b5b73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/AUTOSPHERE/logo.png
// module id = M+P0
// module chunks = 1